import ninegrid from "../index.js";

class nxCollapse extends HTMLElement {
	#target;
	#targetPrevDisplay;

	constructor() {
		super();
		this.attachShadow({ mode: "open" });
	}

	connectedCallback() {
		const targetSelector = this.getAttribute("target");
		this.#target = ninegrid.querySelector(targetSelector);
		//if (!this.#target) return;

		this.#init();
	}

	#init = () => {
		const contents = this.innerHTML.trim();
		this.innerHTML = ""; // 기존 내부 HTML 제거

		const htmlTmpl = document.createElement("template");
		htmlTmpl.innerHTML = `
			<style>
				@import "https://cdn.jsdelivr.net/npm/ninegrid2@${ninegrid.version}/dist/css/nxCollapse.css";
				${ninegrid.getCustomPath(this,"nxCollapse.css")}
			</style>
            
            <button></button>
        `;

		this.shadowRoot.appendChild(htmlTmpl.content.cloneNode(true));

		if (this.#target && this.#target) {
			const collapseBtn = document.createElement("span");
			collapseBtn.className = "collapse-toggle";

			const shadowRoot = this.#target.shadowRoot;
			(shadowRoot || this.#target).appendChild(collapseBtn);

			const style = document.createElement("style");
			style.textContent = `
				span.collapse-toggle {
					position: absolute;
					top: 0;
					right: 0;
					cursor: pointer;
					width: 16px;
					height: 16px;
					border: none;
					transition: all 0.3s ease;
    				background-repeat: no-repeat;
					background-position: center;
					background-size: auto;
					background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="darkgray" class="bi bi-box-arrow-in-up-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M6.364 13.5a.5.5 0 0 0 .5.5H13.5a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 13.5 1h-10A1.5 1.5 0 0 0 2 2.5v6.636a.5.5 0 1 0 1 0V2.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H6.864a.5.5 0 0 0-.5.5"/><path fill-rule="evenodd" d="M11 5.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793l-8.147 8.146a.5.5 0 0 0 .708.708L10 6.707V10.5a.5.5 0 0 0 1 0z"/></svg>');
				}

				span.collapse-toggle:hover {
					background-color: rgba(60, 60, 60, 0.1);
					box-shadow: 0 0 6px rgba(60, 60, 60, 0.4);
					transform: scale(1.2); /* 살짝 확대 */
				}
				
				${shadowRoot ? ":host(.nx-collapse)" : ".nx-collapse"} {
					animation: collapseShrink 0.7s ease forwards;
					pointer-events: none; /* 클릭 방지 */
				}
				
				${shadowRoot ? ":host(.nx-expand)" : ".nx-expand"} {
					animation: expandShrink 0.6s ease forwards;
					pointer-events: none; /* 클릭 방지 */
				}
				
				@keyframes collapseShrink {
					0% {
						opacity: 1;
						transform: scale(1);
						transform-origin: top right;
					}
					100% {
						opacity: 0;
						transform: scale(0);
						transform-origin: top right;
					}
				}
				
				@keyframes expandShrink {
					0% {
						opacity: 0;
						transform: scale(0.5);
						transform-origin: top right;
					}
					100% {
						opacity: 1;
						transform: scale(1);
						transform-origin: top right;
					}
				}
			`;

			(shadowRoot || this.#target).appendChild(style);

			// collapse 시 target 숨기고 복원 버튼 등장
			collapseBtn.addEventListener("click", () => {
				// fade-out 클래스 먼저 넣고 → 일정 시간 후 display: none
				// STEP 1: 복원 버튼 애니메이션 시작 (살짝 빠르게 먼저 등장)
				this.#target.classList.add("nx-collapse");

				setTimeout(() => {
					// STEP 2: target이 줄어드는 shrinking 애니메이션 시작
					//this.style.display = "inline-block";
					this.classList.add("nx-collapse");
				}, 100); // appearing 시작 후 100ms 딜레이로 target 축소 시작

				setTimeout(() => {
					// STEP 3: 실제 target 숨기기
					this.#targetPrevDisplay = this.#target.style.display;
					this.#target.style.display = "none";
				}, 500); // shrinking 애니메이션이 끝나고 실제 제거
			});
		}

		// 복원 시 target 보이고 복원 버튼 사라짐
		/**
		this.shadowRoot.querySelector("button").addEventListener("click", () => {
			this.#target.classList.remove("nx-collapse");
			this.classList.remove("nx-collapse");

			this.#target.style.display = this.#targetPrevDisplay;
			this.style.display = "none";
		}); */

		this.shadowRoot.querySelector("button").addEventListener("click", () => {
			// STEP 1: 복원 대상에 애니메이션 클래스 부여
			this.#target.style.display = this.#targetPrevDisplay;
			this.#target.classList.remove("nx-collapse");
			this.#target.classList.add("nx-expand"); // expandReveal 적용

			setTimeout(() => {
				// STEP 2: target이 줄어드는 shrinking 애니메이션 시작
				this.classList.remove("nx-collapse");
				//this.style.display = "inline-block";
				this.classList.add("nx-expand");
			}, 100); // appearing 시작 후 100ms 딜레이로 target 축소 시작


			setTimeout(() => {
				// STEP 2: 실제 화면에 표시

				//this.style.display = "none"; // 복원 버튼은 사라짐

				// STEP 3: 애니메이션이 끝난 후 pointer-events 복구 (선택적)
				this.#target.classList.remove("nx-expand");
				this.classList.remove("nx-expand");
				//this.#target.style.pointerEvents = "auto";
			}, 600); // 애니메이션과 동일한 시간
		});

	}
}

if (!customElements.get('nx-collapse')) {
	customElements.define("nx-collapse", nxCollapse);
}
